import React from "react";
import dashboardImg from '../assets/dashboardImagy.png'; 

const DashboardInfo = () => {
  return (
    <div className="d-flex flex-column align-items-center py-5" style={{ backgroundColor: "#fff7ec" }}>
      <h2 className="text-center mb-4">🧠 ¿Cómo funciona Imagy?</h2>
      <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ maxWidth: "1200px" }}>
        <div className="p-3" style={{ maxWidth: "500px" }}>
          <ul className="fs-5">
            <li>🗓️ <strong>Configurá días y horarios</strong> desde el calendario.</li>
            <li>✅ Visualizá turnos agendados, disponibles o confirmados.</li>
            <li>👤 <strong>Reservá turnos manualmente</strong> desde el resumen.</li>
            <li>🔁 Modificá la disponibilidad cuando quieras.</li>
          </ul>
          <p className="mt-3 fs-6">
            Imagy es ideal para clínicas, peluquerías, bares, consultorios y más.
            Organizá tu jornada en segundos, sin complicarte.
          </p>
        </div>
        <div className="p-3" style={{ width: '100%', textAlign: 'center' }}>
          <img
            src={dashboardImg}
            alt="Dashboard Imagy"
            style={{
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '12px',
              cursor: 'zoom-in',
            }}
            onClick={() => window.open(dashboardImg, '_blank')}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardInfo;
